import { GoalsIndexPhase, GradeLevel } from '@suntex.fim/enums';

export function gradeLevelToGoalsIndexPhase(
  gradeLevel: GradeLevel,
): GoalsIndexPhase {
  if (gradeLevel >= GradeLevel.Level7) {
    return GoalsIndexPhase.Advanced;
  } else if (gradeLevel >= GradeLevel.Level5) {
    return GoalsIndexPhase.Intermediate;
  } else if (gradeLevel >= GradeLevel.Level3) {
    return GoalsIndexPhase.Elementary;
  } else {
    return GoalsIndexPhase.Early;
  }
}
